import "./style.scss";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonIcon,
  IonInput,
  IonItem,
  IonPage,
  IonRow,
  IonToolbar,
} from "@ionic/react";
// eslint-disable-next-line no-restricted-imports
import { getCognitoSingleton } from "@src/lib/cognito/src/lib/cognitoSingleton";
// eslint-disable-next-line no-restricted-imports
import { getFirebaseSingleton } from "@src/lib/firebase/src";
import { mail } from "ionicons/icons";
import { FC, KeyboardEvent, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { loginWithLink } from "../store/session";

interface LoginRouteState {
  url?: string;
  phone?: string;
  email?: string;
  redirectPath?: string;
}

// TODO: Migrate this route to V2 and remove this file
// Expose loginWithLink function to V2 via provider
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const EmailVerify: FC<{}> = () => {
  const [email, setEmail] = useState<string>("");

  const location = useLocation();
  const dispatch = useDispatch();
  const emailToVerify = localStorage.getItem("emailToVerify");

  // Clear any stale Firebase session before attempting email link sign-in.
  // When a user lands on this page without an email (from query string or
  // localStorage), any existing Firebase session is from a previous login and
  // must be cleared so the new email link flow starts fresh.
  useEffect(() => {
    if (emailToVerify) {
      return;
    }

    const firebaseAuth = getFirebaseSingleton();
    if (firebaseAuth.currentUser) {
      void firebaseAuth.signOut();
      indexedDB.deleteDatabase("firebaseLocalStorage");
    }

    const cognitoAuth = getCognitoSingleton();
    void cognitoAuth.signOut().catch(() => {
      // Ignore errors — there may be no Cognito session
    });
  }, [emailToVerify]);

  useEffect(() => {
    if (emailToVerify) {
      void verify();
    }
  }, [emailToVerify]); // eslint-disable-line react-hooks/exhaustive-deps

  const onEmailChange = (event: Event) => {
    setEmail(event.target?.["value"]);
  };

  const verify = async () => {
    const { url } = (location.state || {}) as LoginRouteState;
    if (!email && emailToVerify) {
      return dispatch(loginWithLink(url as string, emailToVerify));
    }
    dispatch(loginWithLink(url as string, email));
  };

  const onKeyUp = (event: KeyboardEvent<HTMLIonInputElement>) => {
    if (event.key === "Enter") {
      void verify();
    }
  };

  return (
    <IonPage>
      <IonContent class="login-content ion-padding ion-text-center">
        <IonToolbar color="transparent">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/welcome/login" mode="ios" text="Login" color="light" />
          </IonButtons>
        </IonToolbar>
        <IonRow class="ion-align-items-center">
          <IonCol align-self-center>
            <div style={{ margin: "60px 0" }}>
              <h4>Welcome</h4>
              <h4 className="ion-margin-bottom">Please enter your email to verify</h4>
            </div>

            <IonItem lines="none">
              <IonIcon icon={mail} slot="start" color="medium" />
              <IonInput
                class="ion-text-left"
                type="email"
                placeholder="Email"
                onIonChange={onEmailChange}
                value={email}
                onKeyUp={onKeyUp}
              />
            </IonItem>
            <IonButton
              color="primary"
              expand="block"
              size="large"
              class="ion-margin-top ion-margin-bottom login-button"
              onClick={verify}
              disabled={!email}
              id="login-button"
            >
              Verify
            </IonButton>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};

export { EmailVerify };
